export enum AppRoute {
  home = '/',
  help = '/help',
  login = '/login',
  logout = '/logout',
  keycloak = '/keycloak',
  strava = '/strava',
}
